import { Component, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-approve-form',
  templateUrl: './approve-form.component.html',
  styleUrls: ['./approve-form.component.scss'],
})
export class ApproveFormComponent {
  @Input() selection: any;
  approveMessage: string = '';
  title: string = 'ACTIONS.APPROVE';
  action: string = 'ACTIONS.TO_APPROVE';

  constructor(
    private readonly modalService: NgbModal,
    private readonly activeModal: NgbActiveModal
  ) { }

  ngOnInit(): void {
    console.log('selection: ', this.selection);
  }

  onSubmit(): void {
    alert('Thanks!');
  }

  closeModal() {
    this.modalService.dismissAll();
  }

  confirmApproval() {
    this.activeModal.close({
      selection: this.selection,
      message: this.approveMessage,
    });
  }
}
